<style lang="stylus">
.products-price
    font-size 13px
    padding 12px 15px
    .price-red-font
        color rgb(255,95,22)
        float right
    .money-unit

        font-size 8px
    .price-item:first-child
        margin-bottom 2px
    .price-item
        color rgb(121, 125, 130)
        clear both
        line-height 20px
    .price-item:last-child
        margin-bottom 0
.product-item
    .film-seat
        line-height 26px
    .film-tip
        font-size 11px
        color rgb(189, 192, 197)
.price-item-msg
    font-size 11px
    color rgb(189, 192, 197)
.product-express
    font-size 13px
    padding 15px 10px 0 15px
    color rgb(121, 125, 130)
</style>

<template>
  <div class="group">
    <div class="product">
      <div class="product-item item ">
        <div class="product-photo film-photo"><img :src="require('../../../../image/item/card_delay.png')" alt="" /></div>
        <div class="product-info film-info">
          <div class="product-name">卖座券延期服务</div>
          <div class="film-seat">过期时长 {{ cardDelayInfo.overdueDay }}天（按{{ cardDelayInfo.ceilOverdueDay }}天计费）</div>
          <div class="product-price">
            <decimal-price :price="cardDelayInfo.price" decimalSize="10px">
              <span slot="text">/30天</span>
            </decimal-price>
          </div>
        </div>
      </div>
    </div>

    <div class="products-price">
      <div class="price-item">
        商品金额
        <div class="price-red-font">
          <decimal-price :forcePoint="true" :price="totalPrice" decimalSize="10px"></decimal-price>
          <!-- <span class="money-unit">&yen;</span>{{ totalPrice | price2}} -->
        </div>
      </div>
      <div class="price-item">
        延期天数(延至{{ cardDelayInfo.newEndDate }})
        <div class="price-red-font" style="">{{ cardDelayInfo.postponeDay }}天</div>
      </div>

      <div class="price-item-msg">
        {{ returnsAndRefundsMsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import _ from 'underscore'
import op from 'object-path'
import icon from '../../../components/icon'
import CONSTANT from '../../../constant/preorder'
import decimalPrice from '../../../components/decimal-price.vue'
import moment from 'moment'

export default {
  props: ['productsType', 'totalPrice'],
  data() {
    return {
      PRODUCT_TYPE_NORMAL: CONSTANT.PREORDER_PRODUCT_TYPE_NORMAL,
      PRODUCT_TYPE_FILM_TICKET: CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET,
      PRODUCT_TYPE_EXCHANGE_CODE: CONSTANT.PREORDER_PRODUCT_TYPE_EXCHANGE_CODE,
      PRODUCT_GOODS_EXPRESS_FREESHIPPING: CONSTANT.PRODUCT_GOODS_EXPRESS_FREESHIPPING,
      PRODUCT_GOODS_EXPRESS_NORMALSHIPPING: CONSTANT.PRODUCT_GOODS_EXPRESS_NORMALSHIPPING,
      PRODUCT_GOODS_EXPRESS_VIRTUAL: CONSTANT.PRODUCT_GOODS_EXPRESS_VIRTUAL,
      ORDER_TYPE_NORMAL: CONSTANT.PREORDER_ORDER_TYPE_NORMAL,
      ORDER_TYPE_FILM: CONSTANT.PREORDER_ORDER_TYPE_FILM,
      ORDER_TYPE_SHOUFA: CONSTANT.PREORDER_ORDER_TYPE_SHOUFA,
      ORDER_TYPE_GROUPON: CONSTANT.PREORDER_ORDER_TYPE_GROUPON,
      ORDER_TYPE_CARDDELAY: CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY,
    }
  },
  computed: {
    ...mapState({
      orderType: state => state.preorder.orderType, //订单类型
      goods: state => state.preorder.preorderGoods, //商品详情
      filmOrderData: state => state.preorder.filmData, //电影订单数据
      skuList: state => state.preorder.preorderSkuList,
      initInfo: state => state.preorder.orderInitInfo, //普通订单数据
      expressSku: state => state.preorder.expressSku,
      canNotReturns: state => op(state).get('preorder.preorderGoodsExtend.cannotReturnGood'), //能否退货 0,能，1不能
      canNotRefund: state => op(state).get('preorder.preorderGoodsExtend.cannotReturn'), //能否退款 0,能，1不能
      skuExtend: state => op(state).get('preorder.preorderGoodsExtend.list') || [],
    }),
    challName() {
      const hallName = op(this.filmGoodsData).get('seatExtInfo.hallName') || ''
      if (hallName.length > 14) {
        return hallName.slice(0, 14) + '...'
      }
      return hallName
    },
    freeShipping() {
      return (
        this.goods.filter(g => {
          return this.skuExtend.find(v => {
            return v.skuId === g.sku.skuId && v.groupType === this.PRODUCT_GOODS_EXPRESS_FREESHIPPING
          })
        }) || []
      )
    },
    filmGoodsData() {
      if (op(this.filmOrderData).get('goodsInfo.0')) {
        return op(this.filmOrderData).get('goodsInfo.0')
      }
      //   return {
      //     goodsName: '',
      //     goodsCount: '',
      //     price: 0,
      //     seatExtInfo: {
      //       filmLogo: '',
      //       filmName: '',
      //       hallName: '',
      //       seats: '',
      //       watchTime: '',
      //       fee: '',
      //     },
      //   }
      // }
      return null
    },
    filmCinemaData() {
      if (op(this.filmOrderData).get('cinemaInfo')) {
        return op(this.filmOrderData).get('cinemaInfo')
      } else {
        // return {
        //   name: ''
        // }
        return null
      }
    },
    normalShipping() {
      return (
        this.goods.filter(g => {
          return this.skuExtend.find(v => {
            return v.skuId === g.sku.skuId && v.groupType === this.PRODUCT_GOODS_EXPRESS_NORMALSHIPPING && v.productType !== this.PRODUCT_TYPE_EXCHANGE_CODE
          })
        }) || []
      )
    },
    virtualGoods() {
      return (
        this.goods.filter(g => {
          return this.skuExtend.find(v => {
            return v.skuId === g.sku.skuId && v.productType === this.PRODUCT_TYPE_EXCHANGE_CODE
          })
        }) || []
      )
    },

    freeShippingNum() {
      let num = 0
      this.freeShipping.forEach(function(g) {
        num += g.buyCount
      }, this)
      return num
    },

    normalShippingNum() {
      let num = 0
      this.normalShipping.forEach(function(g) {
        num += g.buyCount
      }, this)
      return num
    },
    virtualGoodsNum() {
      let num = 0
      this.virtualGoods.forEach(function(g) {
        num += g.buyCount
      }, this)
      return num
    },

    express() {
      if (!this.expressSku) {
        return null
      }
      return this.expressSku.price * this.expressSku.count
    },
    returnsAndRefundsMsg() {
      let msg = ''
      if (this.productsType === this.PRODUCT_TYPE_FILM_TICKET) {
        if (this.canNotReturns || this.canNotRefund) {
          msg = '该场电影不支持退换票'
        }
      } /* else {
                    if(this.canNotReturns || this.canNotRefund) {
                        msg = "该商品不支持退换货"
                    }
                } */
      return msg
    },
    multipleGoodsList() {
      let lists = []
      if (this.freeShipping.length > 0) {
        lists.push({
          goods: this.freeShipping,
          type: this.PRODUCT_GOODS_EXPRESS_FREESHIPPING,
          totalNum: this.freeShippingNum,
        })
      }
      if (this.normalShipping.length > 0) {
        lists.push({
          goods: this.normalShipping,
          type: this.PRODUCT_GOODS_EXPRESS_NORMALSHIPPING,
          totalNum: this.normalShippingNum,
        })
      }
      if (this.virtualGoods.length > 0) {
        lists.push({
          goods: this.virtualGoods,
          type: this.PRODUCT_GOODS_EXPRESS_VIRTUAL,
          totalNum: this.virtualGoodsNum,
        })
      }
      return lists
    },
    cardDelayInfo() {
      const cardDelayData = this.initInfo[0]
      if (!cardDelayData) {
        return {}
      }
      const overdueDay = moment().diff(moment.unix(cardDelayData.endDate), 'day')
      const mod = overdueDay % 30
      const ceilOverdueDay = mod > 0 ? (Math.floor(overdueDay / 30) + 1) * 30 : overdueDay
      //const ceilOverdueDay = cardDelayData.postponeInfo.postponeDay
      const postponeDay = cardDelayData.postponeInfo.postponeDay
      return {
        cardNum: cardDelayData.cardNum,
        startDate: moment.unix(cardDelayData.startDate).format('YYYY-MM-DD'),
        endDate: moment.unix(cardDelayData.endDate).format('YYYY-MM-DD'),
        overdueDay,
        ceilOverdueDay,
        postponeDay,
        newEndDate: moment.unix(cardDelayData.postponeInfo.newPeriod).format('YYYY-MM-DD'),
        price: cardDelayData.price,
      }
    },
  },
  methods: {
    ...mapActions(['getPreorderSkuExtend', 'getPreorderSkus', 'getSkuListByPreId', 'getFilmPreOrder', 'preorderVerify']),
    async initGoods(key) {
      let self = this
      // 获取商品扩展信息

      let skusInfo = await this.getSkuListByPreId({
        preOrderId: key,
      })
      let skus = skusInfo.skuList
      self.$store.commit('setPreorderSkuList', skus)

      this.getPreorderSkuExtend({
        preOrderId: key,
      })

      if (this.orderType == this.ORDER_TYPE_CARDDELAY) {
        return
      }

      let goodsData = await self.getPreorderSkus({
        skuIds: skus
          .map(s => {
            return s.skuId
          })
          .join(','),
      })

      let list = op(goodsData).get('list')

      _.each(list, oj => {
        _.each(self.initInfo, info => {
          if (op(oj).get('sku.skuId') == op(info).get('skuId')) {
            oj.buyCount = op(info).get('count')
          }
        })
      })

      self.$store.commit('setPreorderGoods', list)
    },
    async initFilm(key) {
      let data = await this.getFilmPreOrder({
        orderId: key,
      })

      let skuList = [
        {
          skuId: op(data).get('sku.skuId'),
          count: op(data).get('sku.count'),
          price: op(data).get('sku.price'),
        },
      ]
      let preorderId = await this.preorderVerify({
        thirdOrderId: key,
        skuList: skuList,
      })
      this.$store.commit('setPreorderSkuList', skuList)
      this.$store.commit('setPreorderId', preorderId.preOrderId)

      this.getPreorderSkuExtend(preorderId)

      if (op(data).get('payOrderId')) {
        return data.payOrderId
      }
    },
    toGoodsList(type) {
      this.$router.push({
        name: 'preorderGoodsList',
        query: {
          type: type,
        },
      })
    },
  },
  components: {
    icon,
    'decimal-price': decimalPrice,
  },
}
</script>
